import styled from "styled-components";
import {Select, Card} from "antd";

export const SelectField = styled(Select)`
    width: 100%;
`;

export const CardField = styled(Card)`
    margin: 20px 0;
    .ant-card-head {
        background: ${props => (props.covered ? "#fafafa" : "transparent")};
    }
`;
export const ImgBg = styled.div`
    height: 64px;
    border: 4px #5b5f63 solid;
    box-sizing: content-box;
    border-radius: 4px;
    cursor: ${props => (props.isEdit ? "unset" : "pointer")};
    background-image: url(${props => props.src});
    width: 184px;
    background-position: center;
    background-size: cover;
    display: flex;
    justify-content: ${props => (props.isEdit ? "flex-end" : "center")};
    align-items: ${props => (props.isEdit ? "flex-start" : "center")};
    z-index: 1;
`;

export const MarkerImg = styled.img`
    width: 20px;
    height: 24.1px;
    margin-right: 10px;
`;

export const DeleteIcon = styled.div`
    margin-left: 10px;
    color: rgba(0, 0, 0, 0.45);
`;

export const IconContainer = styled.div`
    background: #5b5f63;
    height: fit-content;
    border-bottom-left-radius: 4px;
    padding-left: 5px;
    cursor: pointer;
    z-index: 2;
    & > span {
        color: white;
        font-size: 20px;
    }
`;
